import { Notice } from '../desktop'
import '../base/styles.touch.css'

export { Notice }
